import { render, staticRenderFns } from "./lostMasterclasser.vue?vue&type=template&id=0dd363d8&"
import script from "./lostMasterclasser.vue?vue&type=script&lang=js&"
export * from "./lostMasterclasser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports